const toggleBoxes = document.querySelectorAll<HTMLFormElement>('.orderlisttable__checkbox')

const SelectAllOrders = {
  init(target) {
    target.addEventListener('click', (e) => this.onClick(e, target))
  },

  toggleAllSelectBoxes(value) {
    toggleBoxes.forEach((checkbox: HTMLFormElement) => {
      checkbox.checked = value
    })
  },

  onClick(e, target) {
    e.stopPropagation()
    this.toggleAllSelectBoxes(target.checked)
  },
}

export default SelectAllOrders
